function adicionar_plano_init() {
    // Usa delegação de eventos no documento com tratamento definitivo
    document.addEventListener('click', function(e) {
        // Verifica se o clique foi em um botão com a classe específica
        const button = e.target.closest('.card-plano .btn-link');
        
        if (button) {
            // Previne TODOS os comportamentos padrão possíveis
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Tenta bloquear qualquer navegação
            history.pushState(null, '', window.location.href);
            window.onpopstate = function() {
                history.pushState(null, '', window.location.href);
            };

            // Obtém o atributo product-id do botão clicado
            const productId = button.getAttribute('product-id');

            if (!productId) {
                console.error('Produto não encontrado no atributo product-id');
                return;
            }

            // Desabilita temporariamente links e botões
            const links = document.querySelectorAll('a, button');
            links.forEach(link => {
                link.addEventListener('click', preventNavigation, { capture: true });
            });

            // Função para prevenir navegação
            function preventNavigation(event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                return false;
            }

            // Estado de espera visual
            button.classList.add('waiting');

            // Limpa o carrinho
            fetch('/cart/clear.js', {
                method: 'POST',
            })
            .then(function(response) {
                if (!response.ok) {
                    throw new Error('Erro ao limpar o carrinho');
                }
                console.log('Carrinho limpo com sucesso');

                // Adiciona o produto ao carrinho
                return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: productId,
                                quantity: 1,
                            },
                        ],
                    }),
                });
            })
            .then(function(response) {
                if (!response.ok) {
                    return response.json().then((error) => {
                        throw new Error(error.message || 'Erro ao adicionar produto ao carrinho');
                    });
                }
                console.log('Produto adicionado ao carrinho com sucesso');
                
                // Remove bloqueios
                links.forEach(link => {
                    link.removeEventListener('click', preventNavigation, { capture: true });
                });
                
                // Remove estado de espera
                button.classList.remove('waiting');
                
                // Força navegação via JavaScript
                window.location.replace('/pages/fazer-adesao');
            })
            .catch(function(error) {
                console.error(error.message);
                
                // Remove bloqueios em caso de erro
                links.forEach(link => {
                    link.removeEventListener('click', preventNavigation, { capture: true });
                });
                
                // Remove estado de espera
                button.classList.remove('waiting');
            });
        }
    }, { capture: true });
}

// Inicializa apenas uma vez quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', adicionar_plano_init);